<template>
  <div id="login-routes">
    <v-app>
        <router-view/>
    </v-app>
  </div>
</template>

<script>

import Vue from 'vue';
import Vuetify from 'vuetify';
Vue.use(Vuetify);

export default {
    name: 'loginRoutes',
    mounted() {
      document.getElementById("app-loading-4iq").style.display = "none";
    },
}
</script>